/* eslint-disable */
export default {
  unknown: '未知',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
